// Core Type Definitions for Kids Clock

export interface Task {
  id: string;
  profileId: string;
  routineId?: string; // Required for database operations
  label: string;
  icon: string;
  color: string;
  start: string; // HH:MM format
  end: string; // HH:MM format
  order_index?: number;
}

export interface Profile {
  id: string;
  display_name: string;
  theme: string;
  user_id: string;
  created_at?: string;
}

export interface KidProfile {
  name: string;
  theme: 'default' | 'defaultHighContrast' | 'colorBlind';
  clockMode: 'analog' | 'digital';
  locale24h: boolean;
}

export interface Progress {
  date: string; // YYYY-MM-DD format
  completedTaskIds: string[];
}

export enum TaskState {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  PAST_DUE_WINDOW = 'pastDueWindow',
  FADING_OUT = 'fadingOut',
  GONE = 'gone',
  COMPLETED = 'completed'
}

export interface TaskWithState extends Task {
  state: TaskState;
  isCompleted: boolean;
  opacity: number;
  startTime: Date;
  endTime: Date;
  shouldPulse: boolean;
}

export interface TimeSource {
  getCurrentTime(): Date;
  mode: 'live' | 'sim';
  simDate?: Date; // Optional: Only present in 'sim' mode
}

export interface NextTask {
  task: TaskWithState | null;
  countdownText: string;
  timeLeft: number; // milliseconds
}

export interface LabelPosition {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  angle: number;
  task: TaskWithState;
  iconOnly: boolean;
  radialShift: number;
}

export interface AppSettings {
  numberOfClocks: number; // 1-3
  clockProfileIds: string[]; // Which profiles to display in each clock
  clockThemeId: string; // 'kids', 'modern', 'focus'
  showPastTasks?: boolean; // If false, hides past tasks and shrinks active task wedge
  showMinuteTicks?: boolean; // If true, shows minute ticks regardless of theme default
  taskSortingMode?: 'default' | 'layered'; // 'default' = all on layer 0 (active), 'layered' = cascading
  testMode?: boolean; // If true, the clock renders at testPreviewMinutes instead of live time
  testPreviewMinutes?: number; // Minutes-from-midnight the clock previews when testMode is on
}
